import React, { createContext, useContext, useState, useCallback } from 'react';

interface PopupContextType {
  openCount: number;
  openPopup: () => void;
  closePopup: () => void;
  isChatOpen: boolean;
  setIsChatOpen: (isOpen: boolean) => void;
}

const PopupContext = createContext<PopupContextType>({
  openCount: 0,
  openPopup: () => {},
  closePopup: () => {},
  isChatOpen: false,
  setIsChatOpen: () => {},
});

export const usePopup = () => useContext(PopupContext);

export const PopupProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [openCount, setOpenCount] = useState(0);
  const [isChatOpen, setIsChatOpen] = useState(false);

  const openPopup = useCallback(() => setOpenCount((c) => c + 1), []);
  const closePopup = useCallback(() => setOpenCount((c) => Math.max(0, c - 1)), []);

  return (
    <PopupContext.Provider value={{ openCount, openPopup, closePopup, isChatOpen, setIsChatOpen }}>
      {children}
    </PopupContext.Provider>
  );
}; 